<template>
  <tr>
    <td>
      {{ line.amount }}
    </td>
    <td>
      <strong class="font-semibold">
        {{ line.name }}
      </strong>
      <div class="text-gray-700 leading-tight mt-0.5">
        <Info
          v-if="info"
          class="mb-2"
          :text="info.text"
          :date="info.date"
        />
        <Seat
          v-if="info"
          class="mb-2"
          :category="info.category"
          :theme="info.theme"
          :seat="info.seat"
        />
        <div v-if="option">
          {{ option.name }}
        </div>
      </div>
    </td>
    <td>
      {{ formatPrice(line.total) }}
    </td>
  </tr>
  <template v-for="discount in line.discounts">
    <Coupon v-bind="discount" />
  </template>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

<script setup>
import Info from 'Web/Cart/Shared/Info.vue';
import Seat from 'Web/Cart/Shared/Seat.vue';
import Coupon from './Coupon.vue';
import formatPrice from '@/helpers/formatPrice';
import rescue from '@/helpers/rescue';
import { computed } from 'vue';
import find from 'lodash/find';

const props = defineProps({
  cart: {
    type: Object,
    required: true,
  },
  line: {
    type: Object,
    required: true,
  },
});

const info = computed(() => rescue(() => JSON.parse(props.line.info), {
  text: info,
}));

const option = computed(() =>
  find(props.line.options, 'selected')
);

</script>
